import { noLocationRoute } from '../routes/routes'
import differenceInDays from 'date-fns/difference_in_days'

function locationSearchWatcher(context, callback) {
  let { locationSearch } = context.props
  if (locationSearch.locations.foundLocations != null) {
    if (locationSearch.locations.foundLocations.length > 0) {
      context.setState({
        locationId: locationSearch.locations.foundLocations[0].id,
      })
      callback(locationSearch)
    } else if (
      context.state != null &&
      context.state.loading != null &&
      !context.state.loading
    ) {
      context.invalidLocation()
    } else {
      window.location.href = noLocationRoute.path
    }
  }
}

export const safeDifferenceInDays = activationDate =>
  Math.max(differenceInDays(activationDate, new Date()), 0)

export default locationSearchWatcher
